<template>
  <div class="app-container" :style="containerStyle">

    <ibu-nav-bar v-if="showNavBar" />
    <!-- 如果isNavOn为false，则不显示导航栏 padding-top: 0px; -->
    <div class="app-container-content" >
      <VanConfigProvider>
        <!-- router-view指定路由出口 -->
        <!-- <keep-alive :include="['applyClaim', 'pdfViewer']"> -->
        <!-- <keep-alive> -->
        <router-view v-slot="{ Component }">
          <!-- Ensure the key is unique and correctly set -->
          <keep-alive>
            <component :is="Component" :key="$route.name" />
          </keep-alive>
        </router-view>
        <!-- </keep-alive> -->
        <!-- </keep-alive> -->
      </VanConfigProvider>
    </div>

  </div>
</template>
<script setup lang="ts">
import { useAppStore } from '@/stores/index';
import { getEnv, getUUID } from '@/utils/common';
import { onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';

import ibuNavBar from '@/components/ibuNavBar/ibuNavBar.vue';
import { getConfig } from '@/utils/config';
import { parseUrl, getUrlKey } from '@/utils/common';
import { i18n } from '@/utils/i18n/index';

const appStore = useAppStore();
const route = useRoute();


// 是否是移动端
const isMobile = computed((): boolean => {
  // const { isMobile } = userInfoStore();
  return useAppStore().isMobile;
});

// Computed property to determine if nav bar should be shown
const showNavBar = computed(() => {
  // Show nav bar by default unless isNavOn is explicitly set to false
  // 如果isNavOn为null或undefined，则设置为true
  if(route.meta.isNavOn == null || route.meta.isNavOn == undefined) {
    route.meta.isNavOn = true;
  }
  // 如果isNavOn为false，则不显示导航栏
  return route.meta.isNavOn !== false;
});

const isFullScreen = computed(() => {
  if(route.meta.isFullScreen == null || route.meta.isFullScreen == undefined) {
    route.meta.isFullScreen = false;
  }
  return route.meta.isFullScreen;
});

// 计算容器的内边距
// 如果是移动端或全屏模式，则内边距为0，否则为左右135px
const containerPadding = computed((): string => {
  if(isMobile.value == true && isFullScreen.value == true){
    return '0px';
  } else if(isMobile.value == true && isFullScreen.value == false){
    return '50px 0';
  } else if(isMobile.value == false && isFullScreen.value == true){
    return '0px';  
  } else if(isMobile.value == false && isFullScreen.value == false){
    return '50px 135px 0px';
  }
  return '0px';
});

// 合并所有容器样式
// 包含顶部内边距和四周内边距的计算逻辑
const containerStyle = computed(() => {
  return {
    paddingTop: showNavBar.value ? '122px !important' : '0px !important',
    padding: containerPadding.value
  };
});

onMounted(() => {
  // 存储环境变量
  // 保存用户信息
  // saveUserInfoFromQuery();
  methods.initDatasOnMounted();
});

const methods = {
  initDatasBeforeCreate() {
    // 解析跳转链接地址
    const urlParams = parseUrl() || {};
    const { channel = '' } = urlParams;
    appStore.setChannel(channel);
    // 设置配置
    // if (channel === 'kex') {
    appStore.setConfig(getConfig(i18n.global, channel));
    // } else {
    //   appStore.setConfig(config);
    // }
    let lang = getUrlKey('lang', window.location.href);
    if (lang) {
      appStore.setLang(lang);
    }
  },
  initDatasOnMounted() {
    // 初始化数据
    appStore.setEnv(getEnv());
  },
};

const onClick = {
  onClickXXX: () => {},
};

const Apis = {};

methods.initDatasBeforeCreate();

// defineComponent({
//   setup() {

//     // 获取store里的手机号、openId、memId、systemCode
//     const appStore = useAppStore();
//     onMounted(() => {
//       // 存储环境变量
//       alert(111)
//       appStore.setEnv(getEnv());
//       // 保存用户信息
//     });
//     return {
//     };
//   },
// });
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
/* pc */
@media screen and (min-width: 750px) {
  .app-container {
    padding-top: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f3f4f8;
    padding: 0 135px;
  }

  .app-container-content {
    width: 100%;
  }

  .app-container {
    padding-top: 122px;
  }
}

/* mobile */
@media screen and (max-width: 750px) {
  .app-container {
    padding-top: 122px;
  }

  .app-container-content {
    max-width: 1170px;
  }
}
</style>
